import React from "react";
import { PropTypes } from "prop-types";
import Select from "../../util/Select";

const DomainBlockMappingInfo = props => {

  return (
    <div className="AppSection">
 
       <div className="leftColumn margin-height">
            <Select
                labelText={"License Type"}
                className={"margin-height lblNVGreen required"}
                inputClassName={"selectWidth2"}
                optionValues={props.licenseTypes}
                isRequired={true}
                value={props.orgData.LicenseTypeId}
                onChange={props.handleLicenseTypeChange}
                displayFieldName="value"
                valueFieldName="key"
            />

            <Select
                labelText={"Product Family"}
                className={"margin-height lblNVGreen required"}
                inputClassName={"selectWidth2"}
                optionValues={props.productFamilies}
                isRequired={true}
                value={props.orgData.ProductFamilyId}
                onChange={props.handleProductFamilyChange}
                displayFieldName="value"
                valueFieldName="key"
            />

            <div className="margin-height lblNVGreen">
                <label>Is Active</label>
                <input
                    type="checkbox"
                    checked={props.orgData.IsActive}
                    onChange={props.handleIsActiveChange}
                    style={{ marginLeft: '10px' }}
                />
            </div>

            <div className="flex-fill margin-height">
                 <center><button className="btn" onClick={props.onSaveClick} disabled={!props.dataFilled} > Save  </button> </center>
            </div>
        </div>
    </div>
  );
};

DomainBlockMappingInfo.propTypes = {
  isRequired: PropTypes.bool,
  orgData: PropTypes.object,
  licenseTypes: PropTypes.array,
  productFamilies: PropTypes.array,
  handleLicenseTypeChange: PropTypes.func.isRequired,
  handleProductFamilyChange: PropTypes.func.isRequired,
  handleIsActiveChange: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func,
  dataFilled: PropTypes.bool
};

export default DomainBlockMappingInfo;

